import DynamicImage from "./DynamicImage";

export default DynamicImage;